@use "ui/styles/colors";
@use "ui/styles/sizes";

.wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: sizes.$s3 sizes.$s4;
  border-radius: sizes.$s3;
  color: var(--text-color);

  &:hover {
    cursor: pointer;

    &.showBuilderInfo {
      background-color: var(--secondary-background-color);
    }
  }

  :global {
    .avatar_wrapper {
      width: sizes.$s8;
      height: sizes.$s8;
      border-radius: 50%;
      padding: sizes.$s4;
      display: flex;
      justify-content: center;
      align-items: center;
      border-width: sizes.$s2;
      border-style: solid;

      &.avatar_super_admin {
        border-color: colors.$gray70;
      }

      &.avatar_admin {
        border-color: colors.$yellowDark;
      }

      &.avatar_sales_manager {
        border-color: colors.$blue;
      }

      &.avatar_field_staff {
        border-color: colors.$orange;
      }

      &.avatar_sales_agent {
        border-color: colors.$greenDark;
      }

      &.avatar_drafter {
        border-color: colors.$purpleDark;
      }

      &.avatar_sales_team_lead {
        border-color: colors.$redDark;
      }

      &.avatar_estimator {
        border-color: colors.$blueDarkest;
      }

      &.avatar_estimating_manager {
        border-color: colors.$orangeDarkest;
      }

      .avatar {
        min-width: 24px;
        min-height: 24px;
        width: 24px;
        height: 24px;
        color: var(--primary-color);
        border: none;
        background-color: var(--background-color);

        &:hover {
          background-color: var(--secondary-background-color);
        }
      }
    }

    .super_admin {
      &:hover {
        color: var(--primary-color);
        background-color: var(--background-color);
      }

      &.selected {
        color: var(--primary-color);
      }
    }

    .admin {
      &:hover {
        color: var(--primary-color);
        background-color: var(--secondary-background-color);
      }

      &.selected {
        color: colors.$yellowDark;
      }
    }

    .sales_manager {
      &:hover {
        color: colors.$blue;
        background-color: colors.$blueLightest;
      }

      &.selected {
        color: colors.$blue;
      }
    }

    .field_staff {
      &:hover {
        color: colors.$orange;
        background-color: colors.$orangeLightest;
      }

      &.selected {
        color: colors.$orange;
      }
    }

    .sales_agent {
      &:hover {
        color: colors.$greenDark;
        background-color: colors.$greenLightest;
      }

      &.selected {
        color: colors.$greenDark;
      }
    }

    .drafter {
      &:hover {
        color: colors.$purpleDark;
        background-color: colors.$purpleLightest;
      }

      &.selected {
        color: colors.$purpleDark;
      }
    }

    .sales_team_lead {
      &:hover {
        color: colors.$redDark;
        background-color: colors.$redLightest;
      }

      &.selected {
        color: colors.$redDark;
      }
    }

    .estimator {
      &:hover {
        color: colors.$blueDarkest;
        background-color: colors.$blueLightest;
      }

      &.selected {
        color: colors.$blueDarkest;
      }
    }

    .estimating_manager {
      &:hover {
        color: colors.$orangeDarkest;
        background-color: colors.$orangeLightest;
      }

      &.selected {
        color: colors.$orangeDarkest;
      }
    }
  }
}
